import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Search } from 'lucide-react';
import { Input } from '@/shared/components/ui/input';
import { useDebounce } from '@/shared/hooks/useDebounce';
import { cn } from '@/core/lib/utils';

interface MemberSearchProps {
  onChange: (value: string) => void;
  className?: string;
}

export function MemberSearch({ onChange, className }: MemberSearchProps) {
  const { t } = useTranslation('laborPerformance');
  const [inputValue, setInputValue] = useState('');
  const debouncedValue = useDebounce(inputValue, 300);

  useEffect(() => {
    onChange(debouncedValue);
  }, [debouncedValue, onChange]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value);
  };

  return (
    <div className={cn('relative flex items-center', className)}>
      <Search className="absolute left-2.5 h-4 w-4 text-muted-foreground pointer-events-none" />
      <Input
        type="text"
        value={inputValue}
        onChange={handleChange}
        placeholder={t('search.placeholder')}
        data-testid="labor-performance-member-search"
        className="h-9 pl-8"
      />
    </div>
  );
}
